import {
  createPlanId,
  formatGatewayPrices,
  getGatewayDiscountAmount,
  getGatewayDurationDays,
  getGatewayPrice,
  normalizePlanRecord,
} from './planRecords';
import { formatBytes, megabytesToBytes, normalizeMegabytes } from './storageQuota';

export const createStorageAddonProductId = (value = '') =>
  createPlanId(value).replace(/^storage_?/, '') ? `storage_${createPlanId(value).replace(/^storage_?/, '')}` : '';

export const normalizeStorageAddonProduct = (product = {}) => {
  const normalized = normalizePlanRecord(product);

  return {
    ...product,
    ...normalized,
    displayOrder: product.displayOrder ?? product.display_order ?? normalized.displayOrder ?? 0,
    extraQuotaMb: normalizeMegabytes(product.extraQuotaMb ?? product.extra_quota_mb) || 0,
    maxUploadFileMb: normalizeMegabytes(product.maxUploadFileMb ?? product.max_upload_file_mb),
    isActive: product.isActive ?? product.is_active ?? true,
  };
};

export const normalizeStorageAddonProducts = (products = []) =>
  (products || []).map(normalizeStorageAddonProduct);

export const formatStorageAddonQuota = (product = {}) => (
  formatBytes(megabytesToBytes(product.extraQuotaMb ?? product.extra_quota_mb) || 0)
);

export const getStorageAddonGatewayPrice = getGatewayPrice;
export const getStorageAddonGatewayDurationDays = getGatewayDurationDays;
export const getStorageAddonGatewayDiscountAmount = getGatewayDiscountAmount;
export const formatStorageAddonGatewayPrices = formatGatewayPrices;

export const serializeStorageAddonProductPayload = (productForm = {}) => {
  const normalized = normalizeStorageAddonProduct(productForm);

  return {
    name: normalized.name || '',
    description: normalized.description || null,
    extra_quota_mb: Number(normalized.extraQuotaMb || 0),
    max_upload_file_mb: normalized.maxUploadFileMb === null ? null : Number(normalized.maxUploadFileMb),
    gateways: normalized.gateways,
    display_order: Number(normalized.displayOrder ?? 0) || 0,
    is_active: Boolean(normalized.isActive),
    updated_at: new Date().toISOString(),
  };
};
